jQuery(document).ready(function ($) {

	/**
	 * Smooth scroll to anchor
	 */
	$('a[href*="#"]:not([href="#"])').on('click', function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top
				}, 700);

				// remove anchor from url
				var hash = location.hash.replace('#', '');
				if (hash != '') {
					location.hash = '';
				}

				return false;
			}
		}

	});

});
